import { render, staticRenderFns } from "./automationTask.vue?vue&type=template&id=390cccb3&"
import script from "./automationTask.vue?vue&type=script&lang=js&"
export * from "./automationTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390cccb3')) {
      api.createRecord('390cccb3', component.options)
    } else {
      api.reload('390cccb3', component.options)
    }
    module.hot.accept("./automationTask.vue?vue&type=template&id=390cccb3&", function () {
      api.rerender('390cccb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysAutoConfig/automationTask.vue"
export default component.exports